<template>
  <div class="bg">
    <div class="wrapper">
      <div class="tipBox">
        <span class="warn">!</span>
        <span class="warnText">使用银行清算需进行银行卡及身份证信息认证</span>
      </div>
    </div>

    <div class="infoWrapper">
      <div class="infoLine flex">
        <div class="infoTitle">公司名称</div>
        <div class="infoText flex1">
          <input
            placeholder="请输入"
            disabled="disabled"
            v-model="params.enterpriseName"
          />
        </div>
      </div>

      <div class="infoLine flex">
        <div class="infoTitle">法人姓名</div>
        <div class="infoText flex1">
          <input
            placeholder="请输入"
            disabled="disabled"
            v-model="params.legal"
          />
        </div>
      </div>
      <div class="infoLine flex">
        <div class="infoTitle">法人身份证</div>
        <div class="infoText flex1">
          <input
            placeholder="请输入"
            disabled="disabled"
            v-model="params.legalIdCardNo"
          />
        </div>
      </div>
      <div class="infoLine flex">
        <div class="infoTitle">营业执照号</div>
        <div class="infoText flex1">
          <input
            placeholder="请输入"
            disabled="disabled"
            v-model="params.unifiedCode"
          />
        </div>
      </div>
      <div class="infoLine flex">
        <div class="infoTitle">银行卡号</div>
        <div class="infoText flex1">
          <input placeholder="请输入" v-model="params.accountNumber" />
        </div>
      </div>
      <div class="infoLine flex">
        <div class="infoTitle">开户银行</div>
        <div class="infoText flex1" @click="openPop">
          <input
            placeholder="请选择开户银行"
            disabled="true"
            @click="showPop = true"
            v-model="bankName"
          />
        </div>
      </div>
      <div class="infoLine flex">
        <div class="infoTitle">联系人</div>
        <div class="infoText flex1">
          <input
            placeholder="请输入"
            disabled="disabled"
            v-model="params.contact"
          />
        </div>
      </div>
      <div class="infoLine flex">
        <div class="infoTitle">联系人手机</div>
        <div class="infoText flex1">
          <input
            placeholder="请输入"
            disabled="disabled"
            v-model="params.contactPhone"
          />
        </div>
      </div>
      <div class="infoLine flex" style="line-height: 24px;height: 24px;">
        <div class="infoTitle">验证码</div>
        <div class="infoText flex1">
          <input
            style="height: 24px;line-height: 24px;"
            placeholder="请输入"
            v-model="code"
          />
        </div>
        <div
          class="codeButton"
          :class="{ disabled: isDisable }"
          @click="getCode"
        >
          {{ getMobileCodeText() }}
        </div>
      </div>
    </div>

    <div class="flex buttonBox">
      <div class="nextButton flex1" @click="bind">激活</div>
    </div>

    <div v-transfer-dom>
      <popup v-model="show">
        <div class="popup0">
          <div class="uni-padding-wrap flex">
            <div class="uni-title flex1">
              选择支行：<span v-if="bankContacts.length > 0">{{
                bankContacts[bankContactIndex].name
              }}</span>
            </div>
            <div @click="sure">确认</div>
          </div>
          <div class="searchBox flex">
            <input
              class="searchInput flex1"
              placeholder="搜索字段"
              v-model="search.name"
            />
            <span @click="searchBank">搜索</span>
          </div>
          <picker
            :data="pickerList"
            v-model="pickerValue"
            @on-change="changeBankContactName"
          ></picker>
        </div>
      </popup>
    </div>
  </div>
</template>

<script>
import { getClientDetail } from "../../api/client";
import { getCode, codeVerify } from "../../api/bank";
import { companyReCreate, bankList } from "../../api/company";
import { getCompanyDetail } from "../../api/identify";
import { TransferDom, Popup, Picker } from "vux";
export default {
  directives: {
    TransferDom
  },
  components: { Picker, Popup },
  data() {
    return {
      visible: true,
      code: "",
      bankName: "",
      params: {
        bankCardId: "",
        accountNumber: "",
        bankcode: "",
        codeRequestNo: "",
        companyId: "",
        contact: "",
        contactPhone: "",
        enterpriseName: "",
        legalIdCardNo: "",
        legal: "",
        unifiedCode: ""
      },
      bankContacts: [],
      bankContactIndex: 0,
      bankContactValue: "",
      pickerValue: [],
      pickerList: [],
      search: {
        name: ""
      },
      show: false,
      wait_timer: false,
      isDisable: false
    };
  },
  created() {
    this.params.bankCardId = this.$route.query.id;
    this.params.companyId = this.$route.query.companyId;
    this.params.accountNumber = this.$route.query.accountNumber;
    this.params.bankcode = this.$route.query.bankCode;
    this.getAccountDetail();
    this.getBankList();
    getClientDetail()
      .then(res => {
        this.params.contact = res.realName;
        this.params.contactPhone = res.phone;
      })
      .catch(err => {
        this.$showError(err);
      });
  },
  methods: {
    openPop() {
      this.show = true;
    },
    sure() {
      this.bankName = this.bankContacts[this.bankContactIndex].name;
      this.params.bankcode = this.bankContacts[this.bankContactIndex].code;
      this.search.name = "";
      this.show = false;
    },
    searchBank() {
      this.pickerList = [];
      this.bankContactIndex = 0;
      this.getBankList();
    },
    changeBankContactName(e) {
      this.bankContactValue = e;
      for (let i = 0; i < this.bankContacts.length; i++) {
        if (this.bankContacts[i].code == this.bankContactValue) {
          this.bankContactIndex = i;
        }
      }
    },
    getBankList() {
      let that = this;
      bankList(this.search)
        .then(res => {
          this.bankContacts = res;
          for (let i = 0; i < res.length; i++) {
            if (res[i].code == that.params.bankcode) {
              that.bankContactIndex = i;
              that.bankName = that.bankContacts[that.bankContactIndex].name;
            }
          }
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    bind() {
      this.$vux.loading.show();
      codeVerify({
        codeRequestNo: this.params.codeRequestNo,
        verificationCode: this.code
      })
        .then(() => {
          companyReCreate(this.params)
            .then(() => {
              this.$vux.loading.hide();
              this.$router.push({ path: "/bankCard/bankCard?topIndex=1" });
            })
            .catch(err => {
              this.$vux.loading.hide();
              this.$showError(err);
            });
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    getAccountDetail() {
      getCompanyDetail({ companyId: this.params.companyId })
        .then(res => {
          this.params.companyId = res.id;
          // this.params.contact=res.contact
          // this.params.contactPhone=res.contactPhone
          this.params.enterpriseName = res.companyName;
          this.params.legal = res.legalPerson;
          this.params.legalIdCardNo = res.legalPersonId;
          this.params.unifiedCode = res.companyCode;
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    getCode() {
      let that = this;
      if (this.params.contactPhone) {
        this.wait_timer = 59;
        this.isDisable = true;
        let timer_interval = setInterval(function() {
          if (that.wait_timer > 0) {
            that.wait_timer--;
          } else {
            that.isDisable = false;
            clearInterval(timer_interval);
          }
        }, 1000);
        getCode({ mobile: this.params.contactPhone })
          .then(res => {
            this.params.codeRequestNo = res.requestNo;
          })
          .catch(err => {
            this.wait_timer = false;
            this.isDisable = false;
            this.$showError(err);
          });
      } else {
        this.$showError("请先输入预留手机号");
      }
    },
    getMobileCodeText() {
      if (this.wait_timer > 0) {
        return this.wait_timer + "s后获取";
      }

      if (this.wait_timer === 0) {
        return "重新获取";
      }

      if (this.wait_timer === false) {
        return "获取验证码";
      }
    }
  }
};
</script>

<style>
.popup0 {
  background: #fff;
  padding-bottom: 15px;
  height: 800px;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
input {
  width: 100%;
  background: #fff;
  border: none;
}
.bg {
  background: #f3f3f3;
}
.wrapper {
  background: #feeeee;
  overflow: hidden;
  margin-bottom: 20px;
}
.tipBox {
  background: #feeeee;
  overflow: hidden;
}
.warn {
  display: block;
  width: 30px;
  height: 30px;
  border: 1px solid #eb8f8f;
  margin: 14px 20px 16px 30px;
  border-radius: 16px;
  font-size: 12px;
  line-height: 30px;
  color: #eb8f8f;
  text-align: center;
  float: left;
}
.warnText {
  display: block;
  float: left;
  font-size: 11px;
  line-height: 30px;
  padding: 14px 0 16px 0;
  color: #eb8f8f;
}
.infoWrapper {
  margin: 20px 0;
  overflow: hidden;
}
.infoLine {
  padding: 30px;
  background: #fff;
  border-bottom: 1px solid #f1f1f1;
}
.infoTitle {
  width: 140px;
  font-size: 14px;
  color: #474747;
  position: relative;
}
.infoText {
  text-align: right;
  font-size: 14px;
  line-height: 28px;
  color: #262626;
}
.infoText input {
  font-size: 14px;
  line-height: 28px;
  width: 100%;
  text-align: right;
}
.nextButton {
  width: 100%;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
  color: #fff;
  background: #2b80fe;
  text-align: center;
}

.codeButton {
  width: 180px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  background: #007bec;
  border-radius: 10px;
  margin-left: 20px;
}
.buttonBox {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
}

.searchBox {
  font-size: 14px;
  padding: 40px;
  height: 64px;
  line-height: 64px;
}
.searchInput {
  height: 64px;
  line-height: 64px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 0 20px;
  margin-right: 20px;
}
uni-picker-view {
  display: block;
}

uni-picker-view .uni-picker-view-wrapper {
  display: flex;
  position: relative;
  overflow: hidden;
  height: 100%;
  background-color: white;
}

uni-picker-view[hidden] {
  display: none;
}

picker-view {
  width: 100%;
  height: 600px;
  margin-top: 20px;
}
.item {
  line-height: 100px;
  font-size: 16px;
  text-align: center;
}
.uni-padding-wrap {
  padding: 40px;
  font-size: 16px;
}
</style>
